module.exports = __webpack_public_path__ + "static/img/rainbow.4b3b4c15.png";